define([
	"dojo/_base/declare",
	"csi/html/Widget"
], function(declare,Widget) {

	return declare(Widget, {
		getViewPreferenceContext: function() {
			// summary: return context for data package view rather than this template view
			// so that Coversheet custom view will work when used on Data Package
			return this.defView.m_id + "|DataPackage^CoverSheet";
		}
	});
});